import { Skeleton } from '@mantine/core';

import classes from './block-tokens.module.css';

export interface LoadingShimmerProps {
  rows?: number;
}

/**
 * CSS classes for shimmer row widths - defined in block-tokens.module.css.
 */
const SHIMMER_ROW_CLASSES = [
  classes.shimmerRow1,
  classes.shimmerRow2,
  classes.shimmerRow3,
  classes.shimmerRow4,
  classes.shimmerRow5,
] as const;

/**
 * Renders a loading state with Mantine Skeleton components.
 * Shows multiple rows with varying widths for visual interest.
 * Widths are defined as CSS classes in block-tokens.module.css.
 */
export function LoadingShimmer({ rows = 3 }: LoadingShimmerProps) {
  return (
    <div className={classes.loadingShimmer}>
      {Array.from({ length: rows }, (_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: Static skeleton list with no unique identifiers
        <Skeleton className={SHIMMER_ROW_CLASSES[index % SHIMMER_ROW_CLASSES.length]} height={20} key={index} />
      ))}
    </div>
  );
}
